import React, {useContext} from "react";
import {Fade} from "react-awesome-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";

import {illustration, greeting} from "../../portfolio";
import { useTranslation } from 'react-i18next';
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  const { t, i18n } = useTranslation();

  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className={isDark ? "dark-mode section-container greet-container" : "section-container greet-container"} id="greeting">
        <div className={isDark ? "dark-mode greeting-section" : "greeting-section"}>
        <div className="greeting-image-div">
            <img
              alt="photo"
              src={require("../../assets/images/photo.png")}
            ></img>
          </div>
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {t("greeting.heading")} {" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {t("greeting.content")}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text={t("greeting.contact_me")} href="#contact" />
                {greeting.resumeLink && (
                  <Button
                    text={t("greeting.see_my_resume")}
                    newTab={true}
                    href={greeting.resumeLink}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
